import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { VARIANTS as LOGO_VARIANT } from '@prisjakt/ui-store-logo';
import SotyBadgeLink from '../../soty-badge-link';

import { Award, Store } from '../../../../../types';

import { SHOP_LOGO_WIDTH } from '../../../constants';

import * as S from './styles';
import { IconChevronLeft } from '@prisjakt/ui/icon';

type OwnProps = {
  sotyBadge?: Award | null;
  store: Store;
  storeUrl: string;
  titleNode: React.ReactElement;
};

const ReviewsHeader = ({ sotyBadge, store, storeUrl, titleNode }: OwnProps) => {
  const { t } = useContext(AppContext);

  return (
    <header>
      <S.ReviewsHeaderWrapper>
        <div>
          {store.featured ? (
            <S.StoreLogo
              name={store.name}
              storeId={store.id}
              featured={store.featured}
              hasImage={Boolean(store.hasLogo)}
              variant={LOGO_VARIANT.HEADING}
              logoUrl={store.logo}
              width={store.logo ? SHOP_LOGO_WIDTH : undefined}
            />
          ) : (
            <S.TitleText>{store.name}</S.TitleText>
          )}
          <S.ButtonBack to={storeUrl}>
            <IconChevronLeft size={14} color="maybeBlue700" />
            {t('store', 'reviews.back-to-store')}
          </S.ButtonBack>
        </div>
        {sotyBadge?.logo ? (
          <S.SotyBadgeWrapper>
            <SotyBadgeLink sotyBadge={sotyBadge} />
          </S.SotyBadgeWrapper>
        ) : null}
      </S.ReviewsHeaderWrapper>
      {titleNode}
    </header>
  );
};

export default ReviewsHeader;
